module.exports = {"230904001":"东风街道","230904003":"富强街道","230904005":"龙湖街道","230904006":"东胜街道","230904007":"湖东街道","230904008":"通达街道","230904100":"茄子河镇","230904101":"宏伟镇","230904200":"铁山乡","230904201":"中心河乡","230904500":"北兴农场","230904579":"黑龙江红兴隆农垦宝利采金"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230904.json
// module id = 868
// module chunks = 0